import { render, staticRenderFns } from "./DashboardEditor.vue?vue&type=template&id=2bed6b6e&"
import script from "./DashboardEditor.vue?vue&type=script&lang=js&"
export * from "./DashboardEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports